
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"7.99994","y":"12","width":"29","height":"24","fill":"none"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24ZM22.938 31.938C22.6563 32.2197 22.4981 32.6017 22.4981 33C22.4981 33.3983 22.6563 33.7803 22.938 34.062C23.2197 34.3437 23.6017 34.5019 24 34.5019C24.3983 34.5019 24.7803 34.3437 25.062 34.062L34.062 25.062C34.2017 24.9227 34.3125 24.7571 34.3881 24.5749C34.4638 24.3927 34.5027 24.1973 34.5027 24C34.5027 23.8027 34.4638 23.6073 34.3881 23.4251C34.3125 23.2429 34.2017 23.0773 34.062 22.938L25.062 13.938C24.9225 13.7985 24.757 13.6879 24.5748 13.6124C24.3925 13.537 24.1972 13.4981 24 13.4981C23.8028 13.4981 23.6075 13.537 23.4252 13.6124C23.243 13.6879 23.0775 13.7985 22.938 13.938C22.7985 14.0775 22.6879 14.243 22.6124 14.4252C22.537 14.6075 22.4981 14.8028 22.4981 15C22.4981 15.1972 22.537 15.3925 22.6124 15.5748C22.6879 15.757 22.7985 15.9225 22.938 16.062L29.379 22.5H15C14.6022 22.5 14.2206 22.658 13.9393 22.9393C13.658 23.2206 13.5 23.6022 13.5 24C13.5 24.3978 13.658 24.7794 13.9393 25.0607C14.2206 25.342 14.6022 25.5 15 25.5H29.379L22.938 31.938Z","fill":"#444748"}})])
          )
        }
      }
    